import { useStaticQuery, graphql } from 'gatsby';
import { WorkspaceDialogQueryProps } from 'typings';

const WorkspaceDialogQuery = graphql`
  query WorkspaceDialogQuery {
    allStrapiWorkspaceDialog {
      nodes {
        workspaceLabel
        workspaceButton
        locale
      }
    }
  }
`;

export const useStrapiWorkspaceDialog = () => {
  const { allStrapiWorkspaceDialog } = useStaticQuery<WorkspaceDialogQueryProps>(WorkspaceDialogQuery);
  return allStrapiWorkspaceDialog ? allStrapiWorkspaceDialog.nodes : [];
};
